var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login',{attrs:{"type":"import"},on:{"login":function($event){return _vm.login($event)}}},[_c('div',{attrs:{"slot":"feedback"},slot:"feedback"},[_c('div',[_vm._v(" "+_vm._s(_vm.$t('importer.login.message'))+" ")]),(_vm.feedback)?_c('div',{staticClass:"c-form--error"},[_vm._v(" "+_vm._s(_vm.feedback)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }